// Tiny loader for a program's day-scope cards.
//
// Each scopeMap/<program_id>.json has `cards: [...]` in the EXACT same order as
// that program's days/blocks in programs.json (verified position-by-position).
// So the Nth content block you render in the Schedule maps to cards[N]. Each card
// also carries lesson_id + game_id + week so the match can be asserted.

export async function getScopeCards(programId) {
  try {
    const m = await import(`./scopeMap/${programId}.json`);
    return (m.default || m).cards || [];
  } catch {
    return []; // programs without a scope file (e.g. adult/AF) just get no Scope button
  }
}

// Optional helper: assert a card matches a schedule block (defensive check).
export function scopeMatchesBlock(card, block) {
  if (!card || !block) return false;
  const lid = (block.lesson_id || '') === (card.lesson_id || '');
  const gid = (block.game_id || '') === (card.game_id || '');
  return lid && gid;
}
